import request from '@hotmart/request'
import { CONTEXT_REQUEST_IDENTIFIERS, SideMenuResponse, GuideTourResponse, USER_TYPE_INFO } from '.'

export const fetchUserTypeInfo = (): Promise<USER_TYPE_INFO> => request(CONTEXT_REQUEST_IDENTIFIERS.TYPE_INFO)

export const getSideMenu = (): Promise<SideMenuResponse[]> => request(CONTEXT_REQUEST_IDENTIFIERS.SIDE_MENU)

export const getGuideTour = (): Promise<GuideTourResponse> => request(CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR)

export const handleGuideTourUpdate = (viewedGuideTour: boolean): Promise<GuideTourResponse> =>
  request(CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR_UPDATE, { viewedGuideTour })

export const getGuideTourHotmartPRO = (userId: string): Promise<boolean> =>
  request(CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR_HOTMART_PRO, {
    creatorExternalId: userId,
    type: 'PRO_LINK'
  })

export const handleGuideTourHotmartPROUpdate = (userId: string): Promise<void> =>
  request(CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR_HOTMART_PRO_UPDATE, {
    creatorExternalId: userId,
    type: 'PRO_LINK'
  })
